<template>
  <div class="container page">
    <van-nav-bar :title="$t('setting.language')" class="nav-bar" :border="false">
      <template #left>
        <van-icon name="arrow-left" @click="back()" />
      </template>
    </van-nav-bar>
    <div class="items">
      <div
        class="item van-hairline--bottom"
        v-for="item in langOptions"
        :key="item.value"
        @click="changeLang(item.value)"
      >
        <div class="flex_center">
          <img :src="item.flag" alt="" class="flag" />
          <div class="info">{{ item.name }}</div>
        </div>
        <div v-if="lang === item.value" class="check">✓</div>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from 'vant'
import { LANG_OPTIONS, getStoredLang } from '../../utils/lang'
export default {
  name: 'Language',
  data() {
    return {
      lang: getStoredLang(),
      langOptions: LANG_OPTIONS,
      source: ''
    }
  },
  created() {
    this.replaceLang()
  },
  mounted() {
    this.source = this.$route.params.type
  },
  methods: {
    back() {
      window.history.back()
    },
    replaceLang() {
      this.$http({
        method: 'get',
        url: 'replaceLang',
        data: { lang: this.lang }
      }).then(() => {})
    },
    changeLang(lang) {
      Toast.loading({ duration: 200 })
      this.lang = lang
      this.$i18n.locale = lang
      this.replaceLang()
      localStorage.setItem('lang', lang)
      if (this.source == 'setting') {
        this.$router.push({ path: '/' })
      } else {
        this.$router.go(-1)
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import '../../assets/css/base.css';
.check {
  color: #000;
  font-weight: bold;
  font-size: 18px;
}
.flex_center {
  display: flex;
  align-items: center;
  .flag {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    object-fit: cover;
    margin-right: 14px;
  }
  .info {
    font-size: 16px;
    color: #222;
  }
}
</style>
